import { createContext, useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };
  return <AuthCtx.Provider value={{ user, setUser, login, logout }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);

export const ProtectedRoute = ({ children, role = "admin" }) => {
  const { user } = useAuth();
  const { pathname } = useLocation();
  if (user === null) return <div className="min-h-screen grid place-items-center eyebrow">Caricamento…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (role !== "any" && user.role !== role) return <Navigate to={user.role === "client" ? "/portale" : "/admin"} replace />;
  if (user.must_change_password && pathname !== "/portale/password") return <Navigate to="/portale/password" replace />;
  return children;
};
